import { useEffect, useMemo, useState } from 'react';

import { DEFAULT_SETTINGS } from '../../constants';
import { DiceReceiverManager, DiceReceiverManagerEvents } from '../../services';
import type { Settings } from '../../types';

import { ReceiverContext } from './ReceiverContext';

export interface ReceiverContextProviderProps {
    children: React.ReactNode;
}

export const ReceiverContextProvider: React.FC<ReceiverContextProviderProps> = (props) => {
    const [settings, setSettings] = useState(DiceReceiverManager.getInstance().getSettings() ?? DEFAULT_SETTINGS);

    useEffect(() => {
        const receiverManager = DiceReceiverManager.getInstance();

        const callback = (newSettings: Settings) => {
            setSettings(newSettings);
        };

        receiverManager.on(DiceReceiverManagerEvents.SETTINGS_CHANGED, callback);

        return () => {
            receiverManager.off(DiceReceiverManagerEvents.SETTINGS_CHANGED, callback);
        };
    }, []);

    const memoedValue = useMemo(() => ({ settings }), [settings]);

    return <ReceiverContext.Provider value={memoedValue}>{props.children}</ReceiverContext.Provider>;
};
